








































import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {CustomerApi} from "@swagger";

@Component({
  components: {}
})
export default class NewsletterDialog extends BasicComponent {

  formValid: boolean = false;
  firstName: string = "";
  lastName: string = "";
  email: string = "";
  submitted: boolean = false;

  created() {

  }

  submit() {
    if (!this.formValid) return;
    this.submitted = true;
    this.trackEvent("Newsletter", "Akzeptiert");
    new CustomerApi(this.apiConfiguration).registerCustomer({
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email
    }).then(() => {
      this.dialog = false;
    })
  }

  get dialog() {
    return this.$store.getters.newsletterDialogOpen;
  }

  set dialog(value) {
    if (! value && !this.submitted) this.trackEvent("Newsletter", "Abgelehnt")
    this.$store.commit("setNewsletterDialogOpen", value);
  }

}

